import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ROUTE_MENU } from "../../constants";
import * as CONSTANT from "../../constants";
import FavoriteButton from "../../containers/try2/Customization/FavoriteButton";
import styleClasses from './ItemSelection/kidsCombo.module.scss';
import { persistZero } from "../../helpers/helperMethods";
const Heading = (props) => {
  const showFavrtButton = () => {
    if (props?.authInfo?.userId && props?.authInfo?.type !== CONSTANT.GUEST_USER) {
      return true
    }
    return false
  }
  return <>
    {props?.item && <Row>
      <Col>
        <div className="d-flex align-items-center justify-content-between py-0 py-md-3 ">
          {/* <h5 className="text-start text-uppercase d-none d-md-block">{props?.name}</h5> */}
          {/* <div className="d-none d-md-block">
          {showFavrtButton() && (
            <FavoriteButton
              favIcon={false}
              buttonHandler={props?.favoriteButtonHandler}
              className="d-none d-md-block position-static"
              item={props?.item}
              favourite={props?.favourite.some((fav) => fav.item_id === props?.item.id)}
            />
          )}
        </div> */}
        </div>
        <div className="text-start d-md-none">
          <Link
            to={ROUTE_MENU}
            className="btn btn-custom back-arrow-btn f-s14 px-0 mb-0"
          >
            Our Menu
          </Link>
        </div>
        <Row>
          <Col md="3">
            <Image src={`${CONSTANT.REACT_APP_CLOUD_FRONT}${props?.image}`} rounded className={`${styleClasses.kidsCombo_heading_img} d-none d-lg-block w-100`} alt="Chocolate-Dipped Strawberry"/>
            <Image src={`${CONSTANT.REACT_APP_CLOUD_FRONT}${props?.image}`} rounded className="d-lg-none w-100" alt="Chocolate-Dipped Strawberry"/>
          </Col>
          <Col md="9" className="text-start">
            <div className="mb-3 d-flex justify-content-between justify-content-md-end align-items-center">
              <h6 className="h-18 d-md-none pe-3 mb-0">{props?.name}</h6>
              {showFavrtButton() && (
                <FavoriteButton
                  favIcon={false}
                  buttonHandler={props?.favoriteButtonHandler}
                  className="d-md-none position-static flex-fill d-flex justify-content-end"
                  item={props?.item}
                  favourite={props?.favourite.some((fav) => fav.item_id === props?.item.id)} isIconblueFill={false}                />
              )}
            </div>
            <p className="f-sm-s14 d-flex align-items-baseline">{props?.description}
              {showFavrtButton() && (
                <FavoriteButton
                  favIcon={false}
                  buttonHandler={props?.favoriteButtonHandler}
                  className="d-none d-md-block position-static me-3 ms-5"
                  item={props?.item}
                  favourite={props?.favourite.some((fav) => fav.item_id === props?.item.id)} isIconblueFill={false}                />
              )}</p>
            <div className="p-18 f-sm-s14">

              {props?.name}
              {" - "}
              <strong
                className={`font-Vcf ${props?.price > props?.originalPrice && "text-danger"}`}
                data-testid="priceTag"
              >
                Total: ${props?.price ? persistZero(props?.price) : props?.price}
              </strong>
            </div>
          </Col>
          <Col>

          </Col>
        </Row>
      </Col>
    </Row>}</>
};

export default Heading;
